import { render, staticRenderFns } from "./bankruptcy_claim_banner.vue?vue&type=template&id=b65d35ec&"
import script from "./bankruptcy_claim_banner.vue?vue&type=script&lang=js&"
export * from "./bankruptcy_claim_banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports